export enum TransmissionOptions {
  manual = "Manual",
  automatic = "Automatic",
}

export const transmissionOptionsKeys = Object.keys(TransmissionOptions);
